<template>
  <p
    id="toast"
    class="rastar-toast"
    :class="active ? 'active' : '' "
  >{{text}}</p>
</template>

<script>
export default {
  name: "RastarToast",
};
</script>

<style lang="scss" src="./style.scss" scoped></style>